import i18n from '@/app/i18n/global.js'
import moment from 'moment';

//全局过滤器

const timeFormat = (val, format) => {
    try {
        if (val) {
            return format ? moment(val).format(format) : moment(val).format("YYYY-MM-DD HH:mm:ss");
        } else {
            return '--';
        }
    } catch (e) {
        return '--'
    }
}


export {
    timeFormat,
}